import {
  CentreTypeSelector,
  ExaminersReportResponse,
  PagedResultOfExaminersReportResponse,
  api,
} from 'api';
import { rtkQueryApi } from 'store/rtkQueryApi';
import { TableState } from 'types';
import { ExaminersReportFilterType } from './examinersReportTypes';
import {
  getBcCentresIds,
  getIdpCentresIds,
  getPaginationParameters,
  getQueryStringParameters,
} from 'utils';

type ReportParams = TableState<ExaminersReportResponse, ExaminersReportFilterType>;

const mapQueryParams = (params: ReportParams) => ({
  ...getPaginationParameters(params),
  filter: {
    examinerTypes: params.filters.examinerTypes ?? [],
    certificationTypes: params.filters.certificationTypes ?? [],
    statuses: params.filters.statuses ?? [],
    regions: params.filters.regionsIds ?? [],
    countries: params.filters.countriesIds ?? [],
    centres: getBcCentresIds(params.filters.centresIds),
    idpCentres: getIdpCentresIds(params.filters.centresIds),
    centreType: params.filters.centreType ?? CentreTypeSelector.ALL,
  },
});

export const examinersReportApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    getExaminersReportRecords: builder.query<PagedResultOfExaminersReportResponse, ReportParams>({
      query: (params) => {
        const input = getQueryStringParameters(mapQueryParams(params));
        return api.examinerReport.getExaminersReport(input);
      },
    }),
    generateExaminersPdfReport: builder.mutation<File, ReportParams>({
      query: async (params) => {
        const input = getQueryStringParameters(mapQueryParams(params));
        return api.examinerReport.getExaminersPdfReport(input, { format: 'arraybuffer' });
      },
    }),
    generateExaminersExcelReport: builder.mutation<File, ReportParams>({
      query: (params) => {
        const input = getQueryStringParameters(mapQueryParams(params));
        return api.examinerReport.getExaminersExcelReport(input, { format: 'arraybuffer' });
      },
    }),
  }),
});

export const {
  useGetExaminersReportRecordsQuery,
  useGenerateExaminersPdfReportMutation,
  useGenerateExaminersExcelReportMutation,
} = examinersReportApi;
